
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiMeasureGoogle as ObiMeasureGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-measure-google.js';
 
 
 

 
 export const ObiMeasureGoogle = createComponent({
   react: React,
   tagName: 'obi-measure-google',
   elementClass: ObiMeasureGoogleElement,
   events: {
     
   }
  });
 
 